/**
 * Values for @see DesignObject._class.
 *
 * @note See @see DesignClass for @see Design classes not used on @see DesignObject.
 * @note See @see NodeClass for classes used on @see DesignModuleNode.
 */
export enum ObjectClass {
  banner = 'BannerNodeModel',
  base = 'BaseNodeModel',
  begin = 'BeginNodeModel',
  custom = 'CustomNodeModel',
  data = 'DataNodeModel',
  dataAccessCompletion = 'DataAccessCompletionNodeModel',
  dtmf = 'DtmfNodeModel',
  exit = 'ExitNodeModel',
  flushPrompts = 'FlushPromptsNodeModel',
  humanAssistedResolution = 'HumanAssistedResolutionNodeModel',
  input = 'InputNodeModel',
  loopEscalation = 'LoopEscalationNodeModel',
  moduleReference = 'ModuleReferenceNodeModel',
  note = 'NoteNodeModel',
  oasys = 'OasysNodeModel',
  playSavedPrompt = 'PlaySavedPromptNodeModel',
  prompt = 'PromptNodeModel',
  promptReference = 'PromptReferenceNodeModel',
  report = 'ReportNodeModel',
  richText = 'RichTextNodeModel',
  savePrompt = 'SavePromptNodeModel',
  session = 'SessionNodeModel',
  sessionCompletion = 'SessionCompletionNodeModel',
  tab = 'TabNodeModel',
  taskOrchestration = 'TaskOrchestrationNodeModel',
  trustedResponse = 'TrustedResponseNodeModel',
  vxmlRender = 'VXMLRenderNodeModel',
  withFiller = 'WithFillerNodeModel'
}
